import * as React from 'react';
import * as classNames from 'classnames';
import AnimateHeight from '../../../Utils/AnimateHeight';
import './style.css';

export interface UserProfileFormErrorProps {
  className?: string;
  error?: string;
}

export interface UserProfileFormErrorState {
  /* empty */
}

export class UserProfileFormError extends React.Component<
  UserProfileFormErrorProps,
  UserProfileFormErrorState
> {
  render() {
    const { className, error } = this.props;

    return (
      <div className={classNames(className, 'user-profile-form-error')}>
        <AnimateHeight height={error ? 'auto' : 0}>
          <div className="user-profile-form-error-message">{error}</div>
        </AnimateHeight>
      </div>
    );
  }
}

export default UserProfileFormError;



// WEBPACK FOOTER //
// ./src/app/components/UserProfile/UserProfileFormRow/UserProfileFormError/index.tsx